<template>
  <!--按钮组件-->
  <div class="toolbar clearfix">
    <slot name="beforeDefinedSearch"/>
    <span>
      <el-button
        v-if="showDefinedSearch"
        size="medium"
        type="primary"
        class="icon-index-3"
        @click="() => this.customizeSearchVisible = true">自定义搜索</el-button>
      <el-button
        v-if="showDefinedList"
        size="medium"
        type="primary"
        class="icon-index-4"
        @click="() => this.customizefieldListVisible = true">自定义列表</el-button>
    </span>
    <slot name="afterDefinedSearch"/>
    <el-dialog
      v-if="showDefinedList"
      title="自定义列表"
      :visible.sync="customizefieldListVisible"
      class="dialog">
      <jm-search
        v-bind="$attrs"
        :visible="customizefieldListVisible"
        @close-dialog="closeDialogHandle"
        type="list"
        :name="customizeFieldName"/>
    </el-dialog>

    <el-dialog
      v-if="showDefinedSearch"
      title="自定义搜索"
      :visible.sync="customizeSearchVisible"
      class="dialog">
      <jm-search
        v-bind="$attrs"
        :visible="customizeSearchVisible"
        @close-dialog="closeDialogHandle"
        type="search"
        :name="customizeFieldName"/>
    </el-dialog>
    <!--提示框 end v-on:dataVal="dataEvent"-->
  </div>
</template>
<script>
import search from '@/components/pop/search.vue';

export default {
  props: {
    customizeFieldName: {
      type: String,
      required: true,
    },
    showDefinedList: {
      type: Boolean,
      default: false,
    },
    showDefinedSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customizefieldListVisible: false,
      customizeSearchVisible: false,
    };
  },
  methods: {
    /*
    * 切换 自定义列表 || 自定义搜索 组件
    * */
    closeDialogHandle(flag, type) {
      if (type === 'search') {
        this.customizeSearchVisible = !flag;
        return true;
      }
      this.customizefieldListVisible = !flag;
    },
    /*
    * 初始化数据
    * */
    getFilterFields() {
      if (!this.showDefinedSearch) {
        return false;
      }
      this.$http._get({
        url: `/index/field_list/read/type/search/name/${this.customizeFieldName}`,
      }).then(({ data }) => {
        if (data.show) {
          this.filterFiles = Object.keys(data.show.fields);
          this.$store.commit('updateFilterFields', this.filterFiles);
        }
      });
    }
  },
  mounted() {
    this.getFilterFields();
  },
  components: {
    'jm-search': search,
  },
};
</script>
<style src="../../assets/css/common-pc.css"></style>
